import { FabricImage } from 'fabric';

export class BadgeQrCode extends FabricImage {
    constructor(...parameters) {
        super(...parameters);

        this.isQrCode = true;
    }
}
